import { PaginacaoModel } from '../models/paginacao.model';
import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBaseModel } from '../models/base.model';
import { BaseService } from './base.service';
import { IAcaoPlanoAcaoEvidenciaAuditorModel, IAcaoPlanoAcaoEvidenciaModel, IAcaoPlanoAcaoHistoricoModel, IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoFiltroModel, IPlanoAcaoModel, IPlanoAcaoRelatoriaModel, IPlanoAcaoVersaoModel } from '../models/plano-acao-model';
import { IResponsavelWithTipoSelectModel } from '../models/responsaveis.model';
import { IUnidadeGestoraModel } from '../models/unidade-gestora.model';
import { IHistoricoAcaoModel } from '../models/placao-acao-log.model';

@Injectable({
  providedIn: 'root'
})
export class PlanoAcaoService extends BaseService {
  public planoAcaoDate!: IPlanoAcaoModel[];
  private planoAcaoSource = new BehaviorSubject<any>('');
  public currentPlanoAcao = this.planoAcaoSource.asObservable();
  private filtrosAplicadosSource = new BehaviorSubject<IPlanoAcaoFiltroModel | null>(null);
  public filtrosAplicados$ = this.filtrosAplicadosSource.asObservable();
  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public async obter(filtro?: IPlanoAcaoFiltroModel): Promise<PaginacaoModel<IPlanoAcaoModel[]>> {

    const params = this.recuperarParametrosFiltro(filtro);

    return this.httpClient
      .get<IBaseModel<PaginacaoModel<IPlanoAcaoModel[]>>>(`${this.apiBaseUrl}/planoAcao`, { params })
      .toPromise().then(result => {
        this.planoAcaoSource.next(result.dados)
        return result.dados;
      });
  }

  public async obterPorId(id: number): Promise<IBaseModel<IPlanoAcaoModel>> {
    return this.httpClient
      .get<IBaseModel<IPlanoAcaoModel>>(`${this.apiBaseUrl}/planoAcao/${id}`)
      .toPromise();
  }

  public async imprimirPorId(id: number): Promise<IBaseModel<IPlanoAcaoModel>> {
    return this.httpClient
      .get<IBaseModel<IPlanoAcaoModel>>(`${this.apiBaseUrl}/planoAcao/imprimir/${id}`)
      .toPromise();
  }

  public async imprimirRelatoriaPorId(id: number): Promise<IBaseModel<IPlanoAcaoRelatoriaModel>> {
    return this.httpClient
      .get<IBaseModel<IPlanoAcaoRelatoriaModel>>(`${this.apiBaseUrl}/planoAcao/imprimir-relatoria/${id}`)
      .toPromise();
  }

  public async inserir(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/inserir`, data)
      .toPromise();
  }

  public async atualizar(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/atualizar`, data)
      .toPromise();
  }

  public async enviarParaAprovacao(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/enviarParaAprovacao/${id}`, null)
      .toPromise();
  }

  public async finalizarAvaliacao(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/finalizarAvaliacao/${id}`, null)
      .toPromise();
  }

  public async cancelar(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/cancelar`, data)
      .toPromise();
  }

  public async enviarParaExecucao(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/enviarParaExecucao/${id}`, null)
      .toPromise();
  }

  public async finalizarMonitoramentoManual(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/finalizar-monitoramento-manual`, data)
      .toPromise();
  }

  public async habilitarMonitoramento(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/habilitar-monitoramento`, data)
      .toPromise();
  }

  private recuperarParametrosFiltro(filtro: IPlanoAcaoFiltroModel): HttpParams {

    let params = new HttpParams();
    if (filtro) {

      if (filtro.tipo) {
        params = params.append('tipo', filtro.tipo?.toString());
      }
      if (filtro.numeroOsa) {
        params = params.append('numeroOsa', filtro.numeroOsa?.toString());
      }
      if (filtro.prazoFinal) {
        params = params.append('prazoFinal', filtro.prazoFinal?.toString());
      }
      if (filtro.status) {
        params = params.append('status', filtro.status?.toString());
      }
      if (filtro.tipoAuditoriaId) {
        params = params.append('tipoAuditoriaId', filtro.tipoAuditoriaId?.toString());
      }
      if (filtro.unidadeGestoraId) {
        params = params.append('unidadeGestoraId', filtro.unidadeGestoraId?.toString());
      }
      if (filtro.listUnidadeGestoraId && filtro.listUnidadeGestoraId.length > 0) {
        filtro.listUnidadeGestoraId.forEach(id => {
          params = params.append('listUnidadeGestoraId', id.toString());
        });
      }
      if (filtro.pagina) {
        params = params.append('pagina', filtro.pagina?.toString());
      }
      if (filtro.elaboracaoFinalizada !== undefined && filtro.elaboracaoFinalizada !== null) {
        params = params.append('elaboracaoFinalizada', filtro.elaboracaoFinalizada.toString());
      }
      if (filtro.itensPorPagina) {
        params = params.append('itensPorPagina', filtro.itensPorPagina?.toString());
      }
      if (filtro.colunaOrder) {
        params = params.append('colunaOrder', filtro.colunaOrder?.toString());
      }
      if (filtro.direcao) {
        params = params.append('direcao', filtro.direcao?.toString());
      }
    }
    return params;
  }

  public async obterLogAlteracoes(acaoId: number, campo?: string, responsavelId?: string): Promise<IBaseModel<IHistoricoAcaoModel>> {
    let params = new HttpParams();
    if (campo) { params = params.append('campo', campo); }
    if (responsavelId) { params = params.append('responsavelId', responsavelId); }

    return this.httpClient
      .get<IBaseModel<IHistoricoAcaoModel>>(`${this.apiBaseUrl}/planoAcao/acao/${acaoId}/log-alteracoes`, { params })
      .toPromise();
  }

  public notificarFiltrosAplicados(filtros: IPlanoAcaoFiltroModel): void {
    this.filtrosAplicadosSource.next(filtros);
  }

  // NOVO: Método para limpar filtros
  public limparFiltros(): void {
    this.filtrosAplicadosSource.next(null);
  }

  public async obterAcaoPorId(id: number): Promise<IBaseModel<IAcaoPlanoAcaoModel>> {
    return this.httpClient
      .get<IBaseModel<IAcaoPlanoAcaoModel>>(`${this.apiBaseUrl}/planoAcao/acao/${id}`)
      .toPromise();
  }

  public async inserirAcao(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/inserir`, data)
      .toPromise();
  }

  public async atualizarAcao(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/atualizar`, data)
      .toPromise();
  }

  public async excluirAcao(id: number): Promise<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/${id}/excluir`)
      .toPromise();
  }

  public async obterResponsaveis(unidadeGestoraId: number): Promise<IBaseModel<IResponsavelWithTipoSelectModel[]>> {
    return this.httpClient
      .get<IBaseModel<IResponsavelWithTipoSelectModel[]>>(
        `${this.apiBaseUrl}/planoAcao/responsaveis-unidade-gestora/${unidadeGestoraId}`
      )
      .toPromise();
  }

  public async avaliarAcao(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/avaliar`, data)
      .toPromise();
  }

  public async editarAcaoAvaliada(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/editar-avaliada`, data)
      .toPromise();
  }

  public async preencherAcao(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/preencher`, data)
      .toPromise();
  }

  public async enviarAcaoParaMonitoramento(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/enviarParaMonitoramento`, data)
      .toPromise();
  }

  public async monitorarAcao(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/monitorar`, data)
      .toPromise();
  }

  // Demanda 68742 linha 41 (crit 14): inicia nova tentativa de implementação (novo ciclo).
  public async iniciarNovaTentativa(acaoId: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/acao/${acaoId}/nova-tentativa`, {})
      .toPromise();
  }

  public async downloadEvidencia(id: number): Promise<IBaseModel<IAcaoPlanoAcaoEvidenciaModel>> {
    return this.httpClient
      .get<IBaseModel<IAcaoPlanoAcaoEvidenciaModel>>(
        `${this.apiBaseUrl}/planoAcao/acao/evidencia/${id}/download`,
        {}
      )
      .toPromise();
  }

  public async downloadEvidenciaAuditor(id: number): Promise<IBaseModel<IAcaoPlanoAcaoEvidenciaAuditorModel>> {
    return this.httpClient
      .get<IBaseModel<IAcaoPlanoAcaoEvidenciaAuditorModel>>(
        `${this.apiBaseUrl}/planoAcao/acao/evidencia-auditor/${id}/download`,
        {}
      )
      .toPromise();
  }

  public async obterUGsByResponsavelId(responsavelId: string): Promise<IBaseModel<IUnidadeGestoraModel[]>> {
    return this.httpClient
      .get<IBaseModel<IUnidadeGestoraModel[]>>(
        `${this.apiBaseUrl}/planoAcao/unidades-gestoras-responsavel/${responsavelId}`
      )
      .toPromise();
  }

  // Demanda 68742 linha 41 – versionamento (protótipos 4.5–4.7).
  public async gerarVersao(planoAcaoId: number,
    data: { descricao: string }): Promise<IBaseModel<IPlanoAcaoVersaoModel>> {
    return this.httpClient
      .post<IBaseModel<IPlanoAcaoVersaoModel>>(`${this.apiBaseUrl}/planoAcao/${planoAcaoId}/gerar-versao`, data)
      .toPromise();
  }

  public async obterVersoes(planoAcaoId: number): Promise<IBaseModel<IPlanoAcaoVersaoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IPlanoAcaoVersaoModel[]>>(`${this.apiBaseUrl}/planoAcao/${planoAcaoId}/versoes`)
      .toPromise();
  }

  public async obterVersaoPlano(versaoId: number): Promise<IBaseModel<string>> {
    return this.httpClient
      .get<IBaseModel<string>>(`${this.apiBaseUrl}/planoAcao/versao/${versaoId}/plano`)
      .toPromise();
  }

  public async obterVersaoRelatoria(versaoId: number): Promise<IBaseModel<string>> {
    return this.httpClient
      .get<IBaseModel<string>>(`${this.apiBaseUrl}/planoAcao/versao/${versaoId}/relatoria`)
      .toPromise();
  }

  // Demanda 68742 linha 41 – abas de implementação/avaliação (protótipos 4.1–4.4).
  // Ordenação: ciclo mais recente primeiro (ordem de criação decrescente).
  public async obterHistoricoAcao(acaoId: number): Promise<IBaseModel<IAcaoPlanoAcaoHistoricoModel[]>> {
    const res = await this.httpClient
      .get<IBaseModel<IAcaoPlanoAcaoHistoricoModel[]>>(`${this.apiBaseUrl}/planoAcao/acao/${acaoId}/historico`)
      .toPromise();
    if (res && res.sucesso && Array.isArray(res.dados)) {
      res.dados.sort((a, b) => (b.numero ?? b.id ?? 0) - (a.numero ?? a.id ?? 0));
    }
    return res;
  }

  public async finalizarElaboracao(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/finalizarElaboracao/${id}`, null)
      .toPromise();
  }

  public async reabrirElaboracao(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/planoAcao/reabrirElaboracao/${id}`, null)
      .toPromise();
  }
}
